import { paddings } from 'core/styles';
import styled from 'styled-components';

export const CenteredParagraph = styled.p`
text-align: center;
padding: 0 ${() => paddings.defaultPadding};
`;
